// Mapa token -> label (es/en) para fechas especiales de EE.UU.
// La API envia solo tokens; los labels son UI. Compartido por filtros,
// badges de resultados y pills del detalle.
const HOLIDAY_TOKEN_LABELS = {
  "thanksgiving": { es: "Thanksgiving", en: "Thanksgiving" },
  "christmas": { es: "Navidad", en: "Christmas" },
  "new-year": { es: "Año Nuevo", en: "New Year" },
  "mlk-day": { es: "MLK Day", en: "MLK Day" },
  "presidents-day": { es: "Presidents Day", en: "Presidents Day" },
  "easter": { es: "Easter", en: "Easter" },
  "memorial-day": { es: "Memorial Day", en: "Memorial Day" },
  "juneteenth": { es: "Juneteenth", en: "Juneteenth" },
  "fourth-of-july": { es: "4 de Julio", en: "4th of July" },
  "labor-day": { es: "Labor Day", en: "Labor Day" },
  "columbus-day": { es: "Columbus Day", en: "Columbus Day" },
  "veterans-day": { es: "Veterans Day", en: "Veterans Day" },
  "winter-break": { es: "Winter Break", en: "Winter Break" },
  "spring-break": { es: "Spring Break", en: "Spring Break" },
};

// Opciones de la seccion "Fechas especiales" del sidebar (OR entre opciones).
// Cada opcion mapea a los tokens con los que se consulta HolidayFilter.
const HOLIDAY_FILTER_OPTIONS = [
  {
    value: "holiday",
    tokens: ["holiday"],
    label: { es: "Feriados y puentes (cualquiera)", en: "Holidays & long weekends (any)" },
  },
  {
    value: "thanksgiving",
    tokens: ["thanksgiving"],
    label: { es: "Thanksgiving", en: "Thanksgiving" },
  },
  {
    value: "christmas",
    tokens: ["christmas", "new-year"],
    label: { es: "Christmas / Año Nuevo", en: "Christmas / New Year" },
  },
  {
    value: "winter-break",
    tokens: ["winter-break"],
    label: { es: "Winter Break", en: "Winter Break" },
  },
  {
    value: "spring-break",
    tokens: ["spring-break"],
    label: { es: "Spring Break", en: "Spring Break" },
  },
];

const holidayLabel = (token, iso) => {
  const entry = HOLIDAY_TOKEN_LABELS[token];
  if (!entry) return token;
  return entry[iso] || entry.en;
};

// Orden de relevancia para elegir el token primario del badge colapsado
const HOLIDAY_TOKEN_PRIORITY = [
  "thanksgiving",
  "christmas",
  "new-year",
  "winter-break",
  "spring-break",
  "easter",
  "fourth-of-july",
  "memorial-day",
  "labor-day",
  "mlk-day",
  "presidents-day",
  "columbus-day",
  "veterans-day",
  "juneteenth",
];

const specialDateLabel = (iso) => (iso === "es" ? "Fecha especial" : "Special date");

const primaryHolidayToken = (tokens) => {
  for (const p of HOLIDAY_TOKEN_PRIORITY) {
    if (tokens.includes(p)) return p;
  }
  return tokens[0] || null;
};

const optionLabel = (value, iso) => {
  const opt = HOLIDAY_FILTER_OPTIONS.find((o) => o.value === value);
  if (!opt) return value;
  return opt.label[iso] || opt.label.en;
};

// Tokens seleccionables -> array plano para HolidayFilter
const optionTokens = (values) => {
  const set = [];
  (values || []).forEach((v) => {
    const opt = HOLIDAY_FILTER_OPTIONS.find((o) => o.value === v);
    if (opt) opt.tokens.forEach((t) => { if (!set.includes(t)) set.push(t); });
  });
  return set;
};

export { HOLIDAY_TOKEN_LABELS, HOLIDAY_FILTER_OPTIONS, holidayLabel, optionLabel, optionTokens, HOLIDAY_TOKEN_PRIORITY, specialDateLabel, primaryHolidayToken };
